import apiFetch from '@wordpress/api-fetch';
window.addEventListener("DOMContentLoaded", (event) => {
  /* example: ?joinOperator=OR&searchField=keyword&searchOperator=contains&resourceText=Water&resourcesRepository=cdm&searchType=sendbtn&collectionID=p15738coll2!p15738coll5&numberRecords=10 */
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  let searchType;
  let searchTypeA;
  let apiPagingNo = 0;
  let searchTitle;
  let urlLang = "en";
  let searchclass = "regular";

  if (urlParams.has("searchType")) { searchType = urlParams.get('searchType').slice(0, 7); }
  if (urlParams.has("apiPaging")) { apiPagingNo = urlParams.get('apiPaging').slice(0, 3); }
  if (urlParams.has("titleurl")) {
    searchTitle = urlParams.get('titleurl'); searchType = "searchtitle";

  }

  if (urlParams.has("urllang")) {
    urlLang = urlParams.get('urllang');
  }

  let resultsDivCheck = document.querySelector('.resourcesDisplaySection');
  if (resultsDivCheck) {
    searchTypeA = resultsDivCheck.dataset.searchtype;
  }
  
  if (urlParams.has("_sf_s") || urlParams.has("s") || searchTypeA ==="generalsearch") {
    searchType = "searchgeneral";
  }

  /* The following captures publicaitons/title_urls*/
  const urlString = (window.location);
  const urlvalues = new URL(urlString);
  let urlParts = urlvalues.pathname.split("/")
  if (urlParts[1] === "publication") {
    searchTitle = urlParts[2]; searchType = "searchtitle";
  }
  else if (urlParts[2] === "publication") {
    searchTitle = urlParts[1] + '/publication/' + urlParts[3];
    searchType = "searchtitle";
    urlLang = urlParts[1];
  }
  else if (urlParts[1] === "cdmref") {
    const resultsDiv = document.querySelector('.ifpriResourcesSearchBlock');
    if (resultsDiv) {

      const recordCollection = urlParts[2];
      const recordPointer = urlParts[4];
      const recordFilename = urlParts[6];
      const ebraryURL = "https://ebrary.ifpri.org/utils/getfile/collection/" + recordCollection + "/id/" + recordPointer + "/filename/" + recordFilename
      const resultsDivMsg = document.querySelector('.resourcesDisplaySection');
      const urlA = createCustomElement("a", { "class": ["admininfomsg"] }, { "href": ebraryURL, "target": "_blank" }, ebraryURL);
      const urlB = createCustomElement("a", { "class": ["admininfomsg"] }, { "href": ebraryURL, "target": "_blank" }, ".. or click here to go there NOW!");
      const urlHeading = createCustomElement("h4", { "class": ["redirectMsg"] }, {}, "You will shortly be redirected to:");
      const urlParaf = createCustomElement("p", { "class": ["redirectMsg2"] });
      const urlParaf2 = createCustomElement("p", { "class": ["redirectMsg2"] });
      const recordHandle = recordCollection + "/" +recordPointer;

      if (typeof (recordPointer) != "undefined") {

        urlParaf.append(urlA);
        urlParaf2.append(urlB);
        resultsDivMsg.append(urlHeading, urlParaf, urlParaf2);
        let cdm_redirect_event = new IfResourceEvent('ifpri_res_ebrary_redirect', recordHandle, resultsDiv, ebraryURL,);
        const eventSent = cdm_redirect_event.sendEvent();
        if (eventSent) {
          console.log('Redirect notice sent');
          window.setTimeout(function () {
            window.location.href = ebraryURL;
          }, 2000)
        }


      }
      else {
        let cdm_redirect_no = new IfResourceEvent('ifpri_res_redirect_ebrary_no_pointer', 'no_pointer', resultsDiv, 'no_url');
        const evtSent = cdm_redirect_no.sendEvent();
        if (evtSent) {
          console.log('notified no pointer');
        }
      }

    }


  }

  const searchFormA = document.querySelector(".resourcesSearchSelectMain .resourceSearchSelect");

  if (searchType && ["send", "noinput", "sendbtn"].includes(searchType)) {

    const queryData = new FormData();
    queryData.entries = urlParams;
    let resultsDiv2 = document.querySelector('.resourcesDisplaySection');
    resultsDiv2.classList.add('searchForm');
    workParams(urlParams, searchFormA, resultsDiv2);
    for (const [key, value] of urlParams) {
      queryData.set(key, value);
    }

  }

  else if (searchType === "searchtitle") {

    searchclass = "landingRecord";
    let resultsDiv3 = document.querySelector('.resourcesDisplaySection');
    resultsDiv3.classList.add(searchclass);
    searchURLTitle(searchTitle, 'd7');

  }
  else if (searchType === "searchgeneral") {
    let genSearchText ="Food";
    let additional = [];
    let posttypes = [];
    if (urlParams.has("s")) {
      genSearchText = urlParams.get('s');
      urlParams.forEach((value, key) => {
              if (key ==="search_topic")  {
                 const urlVals = decodeURIComponent(value);
                  urlVals.split(",").forEach(function (item) {
                      const thetopic = lookupTopics(item.slice(0, 10));
                      if (thetopic) {
                        additional.push(thetopic.slice(0, 70).trim());
                      }
                  });
              }
              else if (key ==="post_type")  {
                const urlVals = decodeURIComponent(value);
                 urlVals.split(",").forEach(function (item) {
                  posttypes.push(item.slice(0, 50));
                 });
             }
      });

    }
    else if (urlParams.has("_sf_s")) {
      genSearchText = urlParams.get('_sf_s');
    }


    searchclass = "generalSearch";
    let searchInput;
    if (genSearchText) {
      searchInput = betterHTML(betterInput(genSearchText, true));
    }
    else {
      searchInput ="*";
    }
    //console.log(searchInput);
    const actionTypes = ["publication", "profile"]
    
    if (posttypes.length ===0) {
      searchURLGeneral(searchInput, 'd7', additional, posttypes);
    }
    else if (posttypes.length === 1 && actionTypes.includes(posttypes[0])) {
      searchURLGeneral(searchInput, 'd7', additional, posttypes);
    }
    else if (posttypes.length === 1) {
      return;
    }
    else {
       searchURLGeneral(searchInput, 'd7', additional, posttypes);
    }


  }
  
  function lookupTopics(inputID) {
    const topics= document.querySelectorAll('#elastic-search-filter-form input');
    let returnTopic = null;
    topics.forEach(function(topic) {
      if (topic.value ===inputID) {
        const parent = topic.closest('label');
        const text = (parent.innerText || parent.textContent);
        returnTopic = text;
      return returnTopic; 
      
      }
    });
    return returnTopic;
  }

  function workParams(params, searchFormA, resultsDiv2) {
    /* Function transforms URL parameterss into form, for later searches, and API use */
    if (urlParams.has("joinOperator")) {
      const joinOperatortURL = urlParams.get('joinOperator').slice(0, 10);
      const resAndForm = searchFormA.querySelector('.resourcesSearchAndOr');
      if (resAndForm && joinOperatortURL !== "") { resAndForm.value = joinOperatortURL; }
    }

    if (urlParams.has("searchField")) {
      let searchFieldURL = urlParams.get('searchField').slice(0, 10);
      const resFieldForm = searchFormA.querySelector('.resourcesField');
      if (searchFieldURL === "author") { searchFieldURL = "authors"; }
      if (resFieldForm && searchFieldURL !== "") { resFieldForm.value = searchFieldURL; }
    }

    if (urlParams.has("searchOperator")) {
      const searchOperatorURL = urlParams.get('searchOperator').slice(0, 10);
      const resIsForm = searchFormA.querySelector('.resourcesIsCriteria');
      if (resIsForm && searchOperatorURL !== "") { console.log(searchOperatorURL) ;resIsForm.value = searchOperatorURL;}
      /* All not available in the form - only is difference between is and all??? */
      //console.log(resIsForm.value)
      //console.log(resIsForm.value)
    }

    if (urlParams.has("resourceText")) {
      const resourceTextURL = urlParams.get('resourceText').slice(0, 100);
      const resTextForm = searchFormA.querySelector('.resourceText');
      if (resTextForm && resourceTextURL !== "") { resTextForm.value = resourceTextURL; }
    }

    if (urlParams.has("resourcesRepository")) {
      const resourceRepURL = urlParams.get('resourcesRepository').slice(0, 3);
      const resRepForm = searchFormA.querySelector('.resourcesRepository');
      if (resRepForm && resourceRepURL !== "") { resRepForm.value = resourceRepURL; }
    }
    if (urlParams.has("searchType")) {
      const searchTypeURL = urlParams.get('searchType').slice(0, 12);
      const resTypeForm = searchFormA.querySelector('.searchType');
      if (resTypeForm && searchTypeURL !== "") { resTypeForm.value = searchTypeURL; }
    }

    if (urlParams.has("collectionID")) {
      const collectionIDURL = urlParams.get('collectionID').slice(0, 40);
      const resCollIdForm = searchFormA.querySelector('.collectionID');
      if (resCollIdForm && collectionIDURL !== "") { resCollIdForm.value = collectionIDURL; }
    }

    if (urlParams.has("numberRecords")) {
      const numberRecordsURL = urlParams.get('numberRecords').slice(0, 4);
      const resNoRecsForm = searchFormA.querySelector('.numberRecords');
      if (resNoRecsForm && numberRecordsURL !== "") { resNoRecsForm.value = numberRecordsURL; }
    }

    if (urlParams.has("apiPaging")) {
      const apiPagingURL = urlParams.get('apiPaging').slice(0, 3);
      const resAPIPageForm = searchFormA.querySelector('.apiPaging');
      if (resAPIPageForm && apiPagingURL !== "") { resAPIPageForm.value = apiPagingURL; }

    }
    const formData = new FormData(searchFormA);
    searchRecords(formData, searchFormA)

  }

  /* For redirect titles */
  function searchURLTitle(recordTitle, rep = "d7") {
    const searchFormA = document.querySelector(".resourcesSearchSelectMain .resourceSearchSelect");
    const queryData = new FormData();
    queryData.entries = urlParams;

    /* Check database */



    let resultsDiv2 = document.querySelector('.resourcesDisplaySection');

    resultsDiv2.dataset.showfilters = 0;
    resultsDiv2.dataset.citationchecked = 1;
    resultsDiv2.dataset.sortingchecked = 0;
    resultsDiv2.dataset.thumbnailsummary = 1;
    resultsDiv2.dataset.compactshow = 0;
    searchTitle = betterHTML(recordTitle)
    const formData = new FormData(searchFormA);
    formData.set("joinOperator", "AND");
    formData.set("searchField", "title");
    formData.set("searchOperator", "contains");
    formData.set("resourceText", searchTitle);
    let resRepValue = 'd7';
    let resCollIdValue = '8f1e9650-fe87-4e6e-889a-1cacfb747408';
    if (rep === "cdm") {
      resRepValue = 'cdm';
      resCollIdValue = 'p15738coll2!p15738coll5';
    }
    formData.set("resourcesRepository", resRepValue);
    formData.set("searchType", "SearchURL");
    formData.set("collectionID", resCollIdValue);
    formData.set("numberRecords", 1);
    formData.set("apiPaging", 0);

    searchRecords(formData, searchFormA, false, 'searchurls')



  }

  function searchURLGeneral(recordTitle, rep = "d7", additional=[], posttypes=[]) {

    const searchFormA = document.querySelector(".resourcesSearchSelectMain .resourceSearchSelect");
    const queryData = new FormData();
    queryData.entries = urlParams;

    /* Check database */



    let resultsDiv2 = document.querySelector('.resourcesDisplaySection');

    resultsDiv2.dataset.showfilters = 0;
    resultsDiv2.dataset.citationchecked = 1;
    resultsDiv2.dataset.sortingchecked = 0;
    resultsDiv2.dataset.thumbnailsummary = 1;
    resultsDiv2.dataset.compactshow = 0;
    searchTitle = betterHTML(recordTitle)
    if (searchTitle ==="") {
      searchTitle ="*";
    }
    //console.log(`the search title is ${searchTitle}`)
    const formData = new FormData(searchFormA);
    formData.set("joinOperator", "OR");


    formData.set("searchField", "title");
    

    formData.set("searchOperator", "contains");
    formData.set("resourceText", searchTitle);
    let addRules = [];
    if (additional.length > 0) {
      additional.forEach(function(addRule){
        let secondCondition = {};
        secondCondition.resourceText= addRule;
        secondCondition.searchField="keyword";
        secondCondition.searchOperator="is";
        addRules.push(secondCondition);
      })
    }
    /* always also search author */
    let authorCondition = {};
    authorCondition.resourceText= searchTitle;
    authorCondition.searchField="author";
    authorCondition.searchOperator="contains";
    authorCondition.joinOperator="OR";
    addRules.push(authorCondition);


    formData.set("resourceText", searchTitle);
    let resRepValue = 'd7';
    let resCollIdValue = '8f1e9650-fe87-4e6e-889a-1cacfb747408';
    if (rep === "cdm") {
      resRepValue = 'cdm';
      resCollIdValue = 'p15738coll2!p15738coll5';
    }
    formData.set("resourcesRepository", resRepValue);
    formData.set("searchType", "SearchURL");
    formData.set("collectionID", resCollIdValue);

    if (posttypes.length ===1 && posttypes.includes('publication')) {
      formData.set("numberRecords", 20);


    }
    else {
      formData.set("numberRecords", 5);
    }
    formData.set("apiPaging", 0);
    /* URL parts defined at beginning */
    if (urlParts[1] === "page") {
      const pagingValue = urlParts[2]; 
      const theOffset = Number(pagingValue) -1;

      formData.set('apiPaging', theOffset);
    }
    searchRecords(formData, searchFormA, false, 'searchgeneral', addRules)

    

  }

  /* see lib/searchapi_redirects for publications.json */


  const searchForms = document.querySelectorAll(".resourcesSearchSelectMain .resourceSearchSelect");
  searchForms.forEach(function (searchForm) {
    const pagingInput = searchForm.querySelector('.apiPaging');
    pagingInput.value = apiPagingNo;
    searchForm.addEventListener("submit", (event) => {

      searchForm.dataset.apipage = 0;
      const searchType = searchForm.querySelector(".searchType");
      //event.preventDefault();
      if (["sendbtn", "send"].includes(searchType.value)) {
        const formData = new FormData(searchForm);
        return true;
      }
      else {
        event.preventDefault();
      }
      const formData = new FormData(searchForm);
      searchRecords(formData, searchForm)

    });

    const addRule = searchForm.querySelector(".resourceAddRule")
    const searchExpand = searchForm.querySelector('.resourceAdvOptions');

    if (addRule) {
      addRules(addRule, searchForm);
    }

    if (searchExpand && addRule) {
      searchExpand.addEventListener('toggle', (expanded) => {
        addRule.classList.toggle("hidden");
      });
    }

    const searchModifiers = searchForm.querySelector('.ifSearchModifiers');
    if (searchModifiers) {
      addSearchBtnsListeners(searchForm, searchModifiers);
    }
    /* Following for click to submit, but needs modification to allow changing input*/
    /* const searchFormText = searchForm.querySelector('.resourceText');
    if (searchFormText) { 
      searchFormText.addEventListener('click', function(){
        if (searchFormText.value.length > 0) {
          searchForm.submit();
        }

      })
    } */
    
  });

  dynamicSearchListPrompts();
});


function dynamicSearchListPrompts() {

  const ifpResourcesFields = document.querySelectorAll('.ifpResourcesField');
  ifpResourcesFields.forEach(function (ifpResourcesField) {
    ifpResourcesField.addEventListener("change", (event) => {

      const closestForm = ifpResourcesField.closest('.resourceSearchSelect');

      if (closestForm) {
        const closetSearchField = closestForm.querySelector('.resourceText');
        if (closetSearchField) {
          if (event.target.value === "country") {
            closetSearchField.setAttribute("list", "ifpriResourcesCountries");
          }
          else if (event.target.value === "type") {
            closetSearchField.setAttribute("list", "ifpriResourcesTypes");
          }
          else if (event.target.value === "keyword" || event.target.value === "allfields") {
            closetSearchField.setAttribute("list", "ifpriResourcesList");
          }
          else {
            closetSearchField.setAttribute("list", "");

          }
        }
      }
    });
  });

}


/*------------------------------------------------------------------------*/
/*   Switch search Criteria buttons - By Country, By Type, By Keyword     */
/*------------------------------------------------------------------------*/

function addSearchBtnsListeners(searchForm, searchModifiers) {

  const searchBtnModifiers = searchModifiers.querySelectorAll('.ifSearchModifier');
  searchBtnModifiers.forEach(function (searchBtnCtrl) {
    searchBtnCtrl.addEventListener('click', function (evt) {
      searchBtnModifiers.forEach(function (searchBtnA) {
        searchBtnA.classList.remove('selectedOpt');
      })

      const clickedElm = evt.target;
      let selectorField = searchForm.querySelector('.resourcesSearchCriteria');
      selectorField.value = clickedElm.dataset.modifier;
      clickedElm.classList.add('selectedOpt');
      const inputField = searchForm.querySelector('.resourceText');
      if (inputField) {

        let modifierText = clickedElm.dataset.modifier;
        modifierText = modifierText.charAt(0).toUpperCase() + modifierText.slice(1);
        if (modifierText === "Country") { modifierText = "Country / Region" }
        const placholderText = "Search by  " + modifierText;
        inputField.placeholder = placholderText;
        inputField.classList.add('updatedPlaceholder');
        setTimeout(
          function () {
            inputField.classList.remove('updatedPlaceholder');

          }, 5000);


      }




    });

  });

}

function searchRecords(formCriteria, searchForm, append = false, searchtype="", additional=[]) {

  if (searchtype === "searchurls") {
    formCriteria.set("resourcesRepository", "redirects");
    searchtype = "searchurls";
  }

  const searchContainer = searchForm.closest(".ifpriResourcesSearchBlock");
  const resultsDiv = searchContainer.querySelector(".resourcesDisplaySection");

  emptyTheElement(resultsDiv);

  const resWaiting = createCustomElement("h3", { "class": ["resultsSearch"] }, {}, "Searching ...");

  if (searchtype ==="searchgeneral") {
   const adminDiv = document.querySelector('.adminSummary');
   if (adminDiv) { adminDiv.append(resWaiting); }
  }
  else {
    console.log('adding')
    setTimeout(
    function() {
      resultsDiv.append(resWaiting);
    }, 100);

  }




  let AddRules = [];
  /* Dev Note    -- May be issue with several search boxes here */
  const initialRule = Object.fromEntries(formCriteria);
  const additonalRules = document.querySelectorAll('.resourcesSearchSelectRules form');
  additonalRules.forEach(function (rule) {
    const formData = new FormData(rule);
    const formRules = Object.fromEntries(formData)
    AddRules.push(formRules);

  });

  if (searchtype === "searchgeneral") {
    AddRules = additional;
  }


  let repositoryValue = formCriteria.get("resourcesRepository");


  let searchPath = 'ifpri-resources-ifpri-search/v1/searchapi';
  if (repositoryValue && repositoryValue === "cdm") {
    console.trace('getting cdm call');
    searchPath = 'ifpri-resources-ifpri-search/v1/searchebrary';
  }
  else if (repositoryValue && repositoryValue === "redirects") {
    searchPath = 'ifpri-resources-ifpri-search/v1/searchredirects';
  }




  apiFetch({
    path: searchPath,
    method: 'POST',
    data: { "outputType": "searchForm", "initialSearch": initialRule, "rules": AddRules },
  })
    .then(
      (items) => {
        let numFound = 0;
        let searchAgain = false;
        if (items.data.records && items.data.records[0] && items.data.records[0].code === "-2") {
          numFound === 0;
        }
        else { numFound = items.data.records.length; }

        if (numFound === 0) {
          if (searchtype === "searchurls" && repositoryValue === "redirects") {
            formCriteria.set("collectionID", "8f1e9650-fe87-4e6e-889a-1cacfb747408");
            formCriteria.set("repositoryValue", "d7");

            searchRecords(formCriteria, searchForm, false, searchtype = "d7");

          }
          else {
           //console.log(searchtype);
            if (searchtype ==="searchgeneral") {
              let formResults = document.querySelectorAll('.resourcesDisplaySection');
              let resultsDiv = formResults[0];
              resultsDiv.innerHTML = "";
            }
            else {
              const resWaiting = document.querySelector('h3.resultsSearch');
              if (resWaiting) {
                resWaiting.remove();
              }
              displayNoResults();
            }
            
          }


        }
        else {
          //resWaiting.remove();
          const resWaiting = document.querySelector('h3.resultsSearch');
          if (resWaiting) {
            resWaiting.remove();
          }
   
          const numRequested = initialRule.numberRecords;
          displayResults(items, resultsDiv, numRequested, searchForm, searchtype);


        }
        dispalyAdminInfo(resultsDiv, items);
        /* const removeError = document.querySelector('.resourcesError');
        if (removeError) {
          removeError.textContent="";
        }*/

      },
      (error) => {

        displayError(searchtype);
      }
    );

}



function addRules(addRule, searchForm) {
  addRule.addEventListener("click", (event) => {

    const rulesDiv = document.querySelector(".resourcesSearchSelectRules");
    if (rulesDiv) {
      const copyRuleForm = searchForm.cloneNode(true);
      const formData = new FormData(searchForm);
      const fieldSetting = formData.get("searchField");
      const fieldCopy = copyRuleForm.querySelector('.resourcesSearchCriteria');
      fieldCopy.value = fieldSetting;


      const removeRule = copyRuleForm.querySelector('.resourceAddRule');
      removeRule.innerHTML = 'x';
      copyRuleForm.querySelector('details').setAttribute("open", "");
      copyRuleForm.querySelector('.resourcesIsCriteria').disabled = false;
      copyRuleForm.querySelector('.resourcesSubmitform').disabled = false;
      removeRule.addEventListener("click", function (evt) {
        let ancestor = removeRule.closest('.resourceSearchSelect').remove();
        /* this may not work with several forms on the page */
        const rulesDivAmount = document.querySelectorAll('.rulesDiv form')
        if (rulesDivAmount.length === 0) { searchForm.classList.remove("withRules"); }

      });
      copyRuleForm.classList.remove("withRules");
      rulesDiv.append(copyRuleForm);
      searchForm.classList.add("withRules");
      copyRuleForm.addEventListener("submit", (event) => { event.preventDefault(); submitParent(searchForm); });
      dynamicSearchListPrompts();
    }

  })
}
/* Sumbit main form when several rules are present */

function submitParent(searchForm) {
  const formData = new FormData(searchForm);
  searchRecords(formData, searchForm)
  const addRule = searchForm.querySelector(".resourceAddRule")
  const searchExpand = searchForm.querySelector('.resourceAdvOptions');

  if (addRule) {
    addRules(addRule, searchForm);
  }

  if (searchExpand && addRule) {
    searchExpand.addEventListener('toggle', (expanded) => {
      addRule.classList.toggle("hidden");
    });
  }


}

function displayError(searchtype="search") {
  let formResults = document.querySelectorAll('.resourcesDisplaySection');
  let resultsDiv = formResults[0];
  if (resultsDiv) {
    if (searchtype !=="searchgeneral") {
      const resultError = createCustomElement("h3", { "id": "resError", "class": ["resourcesError"] }, {}, "There was a problem searching for results, please try again later");
      resultsDiv.appendChild(resultError)
      const resWaiting = document.querySelector('h3.resultsSearch');
      if (resWaiting) {
        resWaiting.remove();
      }
    
    }
    else {
      const resWaiting = document.querySelector('h3.resultsSearch');
      if (resWaiting) {
        resWaiting.remove();
      }
    }

  }
  else {

    console.log('unable to display error');
  }
}

function displayNoResults() {

  let formResults = document.querySelectorAll('.resourcesDisplaySection');
  let resultsDiv = formResults[0]
  if (resultsDiv) {

    resultsDiv.innerHTML = "";
    const resultError = createCustomElement("h3", { "id": "resError", "class": ["resourcesError"] }, {}, "Sorry, we couldn't find any records based on your search");
    resultsDiv.appendChild(resultError);

  }
  else {
    resultsDiv.innerHTML = "";
    console.log('unable to display error');
  }

}

function removeError() {

  const removeError = document.querySelector('.resourcesError');
  if (removeError) {
    removeError.textContent = "";
  }

}

function createAPIpage(searchForm, resultsDiv, counting, numRequested) {

  //const pagingInput = searchForm.querySelector('.apiPaging');

  let pageValue = 0

  let pagingEnable = false;
  if (resultsDiv.dataset.pagingnumber && parseInt(resultsDiv.dataset.pagingnumber) > 0) {
    pagingEnable = true;
  }

  const apiPaging = createCustomElement("button", { "class": ["resLoadNav", "resLoadMore", "ifResBtn"] }, { "data-paging": pageValue, "data-numrecords": numRequested }, "Load Next " + numRequested + " Records");
  const citationLine = resultsDiv.querySelector('.ifResCitationMore2');


  if (pagingEnable) {
    const pagingParts = resultsDiv.querySelectorAll('.resourcesPagerSection');
    pagingParts.forEach(function (pagingPart) {
      apiPaging.classList.add('resLoadMoreHidden')
      pagingPart.append(apiPaging)
    })

  }
  else if (citationLine) {
    citationLine.append(apiPaging)
  }
  else {
    resultsDiv.append(apiPaging)
  }

  apiPaging.addEventListener('click', function (evt) {
    let pagingValue = searchForm.dataset.apipage;
    let newPage = Number(pagingValue) + 1
    searchForm.dataset.apipage = newPage;
    const theOffset = (newPage * numRequested) + 1;
    const formData = new FormData(searchForm);
    formData.set('apiPaging', theOffset);
    searchRecords(formData, searchForm, true); // true = append to results
    const scrollDiv = searchForm.offsetTop;
    window.scrollTo({ top: scrollDiv, behavior: 'smooth' });

  })


}


function displayResults(dataObj, resultsDiv, numRequested, searchForm, searchtype = "") {


  if (resultsDiv) {

    const numResults = dataObj.data.records.length;

    if (dataObj.data.records === null || numResults === 0) {
      resultsAppend = createCustomElement("div", { "class": ["resultsNone"] }, {}, "Sorry, we couldn't find any records based on your search");
      const resWaiting = document.querySelector('h3.resultsSearch');
      if (resWaiting) {
        resWaiting.remove();
      }
    
    }
    else {
      let recordsDisplay;
      if (searchtype === "searchgeneral") {
        recordsDisplay = displayGeneral(dataObj, resultsDiv, numResults, searchtype); // Includes filters

      }

      else {
        recordsDisplay = displayRecords(dataObj, resultsDiv, numResults, searchtype); // Includes filters

      }


      if (searchtype != 'searchgeneral') {
        resultsDiv.append(recordsDisplay)
      }

      if (searchtype != 'searchgeneral' && resultsDiv.dataset.pagingnumber && parseInt(resultsDiv.dataset.pagingnumber) > 0) {
        createPaging(resultsDiv, numResults);

      }
      if (searchtype != 'searchgeneral' && searchtype !== "single") {
        createSorting(resultsDiv, numResults);
      }


      if (searchtype != 'searchgeneral' && numResults >= Number(numRequested)) {
        createAPIpage(searchForm, resultsDiv, numResults, numRequested);
      }
    }

  }


}

/* First remove current paging, sorting, filters etc */



function displayRecords(dataObj, resultsDiv, numResults, searchtype = "") {
  const parentSearchDiv = resultsDiv.closest(".ifpriResourcesSearchBlock");



  /* Replace the following List view on the page */

  const nextListView = parentSearchDiv.nextElementSibling;
  if (nextListView && nextListView.classList.contains("ifpriResourcesListBlock")) {
    nextListView.classList.add("listBlockAdjacentHidden");
  }


  let pagingAmt;
  let pagingNum;
  pagingAmt = resultsDiv.dataset.pagingnumber;
  pagingNum = parseInt(pagingAmt);

  let resultsContainer = createCustomElement("div", { "class": ["resultsContainer", "regular"] })

  let pagingEnable = false;


  if (resultsDiv.dataset.pagingnumber && parseInt(resultsDiv.dataset.pagingnumber) > 0 && numResults >= pagingNum) {
    pagingEnable = true;
  }

  /* No pager if amount of results is less than or equal to the paging number */

  if (resultsDiv) {

    let resultsAppend;
    let citationCopy;
    let citationsSpan;


    if (searchtype === "") { searchtype = "form"; }
    let resultsOuterDiv = createCustomElement("div", { "class": ["resourcesOutputsInnerWrapper", "display", "regular", searchtype] })

    if (resultsDiv.dataset.showfilters === "1") {
      //echo '<div class="outputsWithDisplayFilters globalIfResStyle">';
      let vertFilters = createVerticalFilters(dataObj.data)
      resultsAppend = createCustomElement("div", { "class": ["outputsWithDisplayFilters", "globalIfResStyle"] });
      resultsAppend.append(vertFilters);

    }
    else {
      resultsAppend = createCustomElement("div", { "class": ["resultsInner"] });
    }

  

    dataObj.data.records.forEach(function (record, index) {

      if (!record.title) { return; }
      let detailsAppend = createCustomElement("details", { "class": ["detailsItem"] });
      let btnsSection = createCustomElement("section", {"class": ["resourceBtnSection", "resourceSearch"]})

      if (resultsDiv.dataset.compactshow === "1") {
        const summaryAppend = createCustomElement("summary", { "class": ["recordDetails", "ifResBtn"] }, { "title": "click to view more" }, "Details");
        detailsAppend.append(summaryAppend);
        detailsAppend.classList.add('detailsBtnShwon')
        summaryAppend.addEventListener("click", function (evt) {
          let detailsClicked = new IfResourceEvent('ifpri_res_details_click', record.handle, resultsDiv);
          detailsClicked.sendEvent();
        })
      }
      else {
        btnsSection.classList.add('detailsBtnHidden')
      }



      let detailsDiv;
      if (searchtype === "single") {
        detailsDiv = createCustomElement("div", { "class": ["recordDetailsDiv", "recordSingle"] });

      }
      else {
        detailsDiv = createCustomElement("div", { "class": ["recordDetailsDiv"] });
      }
      let thelink = "/publications";
      let theDldTxt = "More";
  
      if (record['downloadLink']) {
        thelink = record['downloadLink'];
        theDldTxt = "Download";
      }
      else if (record['uri']) {
        thelink = record['uri'];
        theDldTxt = "View";
      }
  



      let allTermsList = "";
      let searchType;
      let searchDate;
      let searchTitle;

      record.authorsArray.forEach(function (a) {
        allTermsList += a + ";";
      });

      record.keywords.forEach(function (b) {
        if (b !== "") {

          allTermsList += b + ";";
        }
      });
      record.countries.forEach(function (c) {
        if (c !== "") {
          allTermsList += c + ";";
        }
      });
      if (record['type']) {
        allTermsList += record['type'] + ";";
        searchType = record['type'].slice(0, 10);
      }
      if (record['issued']) {
        allTermsList += record['issued'] + ";";
        searchDate = record['issued'].slice(0, 10);

      }
      if (record['project_id']) {
        allTermsList += record['project_id'] + ";";
      }

      searchTitle = record['title'].replace(/\s/g, '').slice(0, 100)



      const resWrap = createCustomElement("div", { "class": ["resultsItem", "resourceItemRecord"] }, { "data-allterms": allTermsList, "data-sorttitle": searchTitle, "data-sorttype": searchType, "data-sortdate": searchDate });


      if ((resultsDiv.dataset.typechecked = "1") && record['type']) {
        const resType = createCustomElement("p", { "class": ["outputType"] }, {}, record['type']);
        resWrap.append(resType);
      }
      let imgAppend;
      if (searchtype === "single" || searchtype==="searchurls") {
        //With single items / redirect pages, show the thumbnail
        const imageFile = dataObj.data.records[0].thumbLocal;
          let imgFull = "res_dspace/resource.jpg"
        if (imageFile !== "resource.jpg") {
          const subfolderName = imageFile.substr(6, 3);
          imgFull = "res_dspace/" + subfolderName + "/" + imageFile;
        } 
        if (dataObj.data.records[0].collection && dataObj.data.records[0].collection.substr(1, 4) ==="p157")  { 
          imgFull = "res_ebrary/" +imageFile; 
        }
        let imgclass ="single";
        if (searchtype ==="searchurls") {
          imgclass="searchurls";
        }
        
        imgAppend = createCustomElement("img", { "class": ["resourceThumb", "repositoryThumb", imgclass] }, { "title": "Cover of publication or resource", "src": "/wp-content/uploads/" + imgFull }, "Details");
        resultsOuterDiv.append(imgAppend);
      }

      if (record['title']) {
        const resTitle = createCustomElement("h4", { "class": ["ifResourcesTitle"] }, {}, record['title']);
        resWrap.append(resTitle);
        resTitle.addEventListener("click", function (e) {


          e.preventDefault();
          const parnt = resTitle.closest(".resultsItem");
          if (parnt) {
            const detals = parnt.querySelector("details");
            if (detals) {
              if (detals.open == false) {
                let detailsClicked = new IfResourceEvent('ifpri_res_details_title', record.handle, resultsDiv);
                detailsClicked.sendEvent();
                detals.open = true;
              }
              else {
                detals.open = false;

              }

            }
            else {
              console.log('no details');
            }
          }
          else {
            console.log('no prt');
          }
        });


      }

      if (record['series']) {
        const resSeries = createCustomElement("span", { "class": ["dspaceSub", "series", "resultSeries"] }, {}, record['series']);
        resWrap.append(resSeries);
      }

      if (record['issued']) {
        const resYear = createCustomElement("span", { "class": ["dspaceSub", "year", "resultYear"] }, {}, record['issued']);
        resWrap.append(resYear);
      }

      if (record['authorsArray'].length > 0) {
        const resAuthor = createCustomElement("span", { "class": ["dspaceSub", "ifresAuthors"] }, {}, record['authorsArray'].join("; "));
        resWrap.append(resAuthor);
      }


      
      detailsDiv = createRecordDetails(record, resultsDiv,  detailsDiv);

      if (resultsDiv.dataset.compactshow === "1") {
        detailsAppend.append(detailsDiv)
        btnsSection.append(detailsAppend);
      }
      else {
        btnsSection.append(detailsDiv);
      }

      const link2btn = createCustomElement("button", { "class": ["resourceDownloadBtn", "ifResBtn", "ifResBtnGeneral"] });
      const link2 = createCustomElement("a", { "class": ["searchDownload"] }, { "href": thelink, "target": "_blank" }, theDldTxt);
      link2btn.append(link2)
      link2.addEventListener("click", function (evt) {
        let downloadBClicked = new IfResourceEvent('ifpri_res_download_search', record.handle, resultsDiv);
        downloadBClicked.sendEvent();
      });


      if (resultsDiv.dataset.compactshow === "1") {
        btnsSection.append(link2btn);
        resWrap.append(btnsSection);
      }
      else {
        resWrap.append(btnsSection);
        resWrap.insertBefore(link2btn, btnsSection);
      }

      
      resultsOuterDiv.append(resWrap);
    });
    resultsAppend.append(resultsOuterDiv);

    /*For redirects -- just record what is available */
    if (searchtype ==="searchurls") {
     
      let cdm_redirect_event = new IfResourceEvent('ifpri_res_landing_redirection', dataObj.data.records[0].handle, resultsDiv, '');
      const eventSent = cdm_redirect_event.sendEvent();
    }


    /* Citation copy page listener */

    let citationText = "";
    let citationAmt = 0;
    const collectAllCitations = resultsAppend.querySelectorAll('.resultCitation');
    collectAllCitations.forEach(function(citation) {
      citationAmt++;
      citationText += citation.textContent +"\n\n";

    })




    citationCopy = createCustomElement("div", { "class": ["ifres_list_citations_btn", "dashicons", "dashicons-plus-alt", "ifResBtn"] }, { "data-allcitations": citationText });
    let theCitationText = "Copy all " + citationAmt + " citations";
    if (citationAmt ===1) {
      theCitationText = "Copy citation";
    }

    citationsSpan = createCustomElement('span', {}, { "title": "Click to copy all citations in the above list to your clipboard" }, theCitationText);



    citationCopy.append(citationsSpan);
    const citationCopyBefore = citationCopy.cloneNode(true)
    //const citationCopyBefore = Object.assign({}, citationCopy);
    //const citationCopyBefore = JSON.parse(JSON.stringify(citationCopy));

    const citationCopies = [citationCopy, citationCopyBefore];

    citationCopies.forEach(function (citationAllEl) {
      citationAllEl.addEventListener('click', function (e) {
        let copied;
        let citationText = citationCopy.dataset.allcitations;
        
        if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
          copied = copyTextToClipboard(citationText);
        }
        if (copied) {
          citationAllEl.classList.remove('dashicons-plus-alt')
          citationAllEl.classList.add('dashicons-yes-alt')
          setTimeout(
            function () {

              citationAllEl.classList.remove('dashicons-yes-alt')
              citationAllEl.classList.add('dashicons-plus-alt')
            }, 2500);

        }

      })


    });

    const citationPageWrapper = createCustomElement("div", { "class": ["ifResCitPaging", "ifResCitationMore"] });
    const citationPageWrapper2 = citationPageWrapper.cloneNode(true);
    citationPageWrapper2.classList.add('ifResCitationMore2')
    //const totalRecords = parseInt(dataObj.data.records.length);

    if (searchtype !== "single") {

      citationPageWrapper.append(citationCopyBefore);
      citationPageWrapper2.append(citationCopy);

    }

    //removeCitationAndPagers();
    let resultsAndCitations = createCustomElement("div", { "class": ["resourcesCitations"] })

    if (citationText !== "") {
      resultsAndCitations.append(citationPageWrapper, resultsAppend, citationPageWrapper2);
    }
    else {
      resultsAndCitations.append(resultsAppend);
    }
    const resWaiting = document.querySelector('h3.resultsSearch');
    if (resWaiting) {
      resWaiting.remove();
    }
    return resultsAndCitations;


  }
}

/*****************************************************
* Record details
* ************************************** */
 
function createRecordDetails(record, resultsDiv, detailsDiv) {


  if (record['abstract'] && resultsDiv.dataset.abstractchecked === "1") {
    const resAbstract = createCustomElement("p", { "class": ["resultSearchAbstract"] }, {}, record['abstract']);
    detailsDiv.append(resAbstract);
  }


  if (record['issued']) {
    const dspaceDetailsWrapYr = createCustomElement("div", { "class": ["dspaceDetails"] }, {});
    const resAYearwrap = createCustomElement("p", { "class": ["detailsDesc", "detailsYear"] }, {}, "Year published");
    const resYear = createCustomElement("p", { "class": ["detailsDetails"] }, {}, record['issued']);
    dspaceDetailsWrapYr.append(resAYearwrap);
    dspaceDetailsWrapYr.append(resYear);
    detailsDiv.append(dspaceDetailsWrapYr);
  }
  if (record['authorsArray'].length > 0 && (resultsDiv.dataset.authorschecked === "1")) {

    const dspaceDetailsWrapAths = createCustomElement("div", { "class": ["dspaceDetails"] }, {});
    const resAuthorwrap = createCustomElement("p", { "class": ["detailsDesc", "detailsAuthors"] }, {}, "Authors");
    const resAuthors = createCustomElement("p", { "class": ["detailsDetails"] }, {}, record['authorsArray'].join("; "));
    dspaceDetailsWrapAths.append(resAuthorwrap);
    dspaceDetailsWrapAths.append(resAuthors);
    detailsDiv.append(dspaceDetailsWrapAths);
  }


  if (record['citation'] && (resultsDiv.dataset.citationchecked === "1")) {


    const dspaceDetailsWrapCit = createCustomElement("div", { "class": ["dspaceDetails"] }, {});
    const resCitWrap = createCustomElement("p", { "class": ["detailsDesc", "detailsCitation"] }, {}, "Citation");
    const citationElm = createCustomElement("p", { "class": ["resultCitation"] }, { }, record['citation']);
    const citationSpan = createCustomElement("span", { "class": ["citationClipboard", "dashicons", "dashicons-plus-alt"] }, { "title": "Click to copy to citation clipboard" }, "")
    citationElm.addEventListener('click', function (e) {
      let citationTextItm = citationElm.textContent;
      const copied = copyTextToClipboard(citationTextItm)
      if (copied) {

        let spanDiv = citationElm.querySelector('span')

        if (spanDiv) {
          spanDiv.classList.remove('dashicons-plus-alt')
          spanDiv.classList.add('dashicons-yes-alt')
          setTimeout(
            function () {
              spanDiv.classList.remove('dashicons-yes-alt')
              spanDiv.classList.add('dashicons-plus-alt')
            }, 2500);
        }
        let cdm_redirect_event = new IfResourceEvent('ifpri_res_citation_item_search', record.handle, resultsDiv);
        const eventSent = cdm_redirect_event.sendEvent();
      }

    })
    dspaceDetailsWrapCit.append(resCitWrap);
    citationElm.append(citationSpan);
    dspaceDetailsWrapCit.append(citationElm);
    detailsDiv.append(dspaceDetailsWrapCit);
  }
  if (record['countries'].length > 0 && (resultsDiv.dataset.countrieschecked === "1")) {
    const dspaceDetailsWrap2 = createCustomElement("div", { "class": ["dspaceDetails"] }, {});
    const resCtysWrap = createCustomElement("p", { "class": ["detailsDesc", "detailsCountries"] }, {}, "Country/Region");
    const resCtys = createCustomElement("span", { "class": ["resultCountries"] }, {}, record['countries'].join("; "));
    dspaceDetailsWrap2.append(resCtysWrap);
    dspaceDetailsWrap2.append(resCtys);
    detailsDiv.append(dspaceDetailsWrap2);
  }

  if (record['keywords'].length > 0 && (resultsDiv.dataset.keywordschecked === "1")) {

    const dspaceDetailsWrap = createCustomElement("div", { "class": ["dspaceDetails"] }, {});
    const resKEyswrap = createCustomElement("p", { "class": ["detailsDesc", "detailKeywords"] }, {}, "Keywords");
    const resKeys = createCustomElement("p", { "class": ["detailsDetails"] }, {}, record['keywords'].join("; "));
    dspaceDetailsWrap.append(resKEyswrap);
    dspaceDetailsWrap.append(resKeys);
    detailsDiv.append(dspaceDetailsWrap);
  }

  if (record['language'] && (resultsDiv.dataset.languagechecked === "1")) {
    const dspaceDetailsWrap4 = createCustomElement("div", { "class": ["dspaceDetails"] }, {});
    const resLangWrap = createCustomElement("p", { "class": ["detailsDesc", "detailsLanguage"] }, {}, "Language");
    const resLang = createCustomElement("p", { "class": ["resultLang"] }, {}, record['language']);
    dspaceDetailsWrap4.append(resLangWrap);
    dspaceDetailsWrap4.append(resLang);
    detailsDiv.append(dspaceDetailsWrap4);
  }


  if (record['series'] && (resultsDiv.dataset.serieschecked === "1")) {
    const dspaceDetailsWrap4a = createCustomElement("div", { "class": ["dspaceDetails"] }, {});
    const reSeriWrap = createCustomElement("p", { "class": ["detailsDesc", "detailsSeries"] }, {}, "Series");
    const resSeri = createCustomElement("p", { "class": ["resultSeries"] }, {}, record['series']);
    dspaceDetailsWrap4a.append(reSeriWrap);
    dspaceDetailsWrap4a.append(resSeri);
    detailsDiv.append(dspaceDetailsWrap4a);

  }


  if (record['openAccess'] && (resultsDiv.dataset.openaccesschecked === "1")) {
    const dspaceDetailsWrap5 = createCustomElement("div", { "class": ["dspaceDetails"] }, {});
    const resAccWrap = createCustomElement("p", { "class": ["detailsDesc", "detailsAccess"] }, {}, "Access/Licence");
    const resAccessRightCol = createCustomElement("p", { "class": ["resultAccess"] }, {}, "");
    const resAccess = createCustomElement("span", { "class": ["resultAccessSp"] }, {}, record['openAccess']);
    resAccessRightCol.append(resAccess)
    if (record['license'] && (resultsDiv.dataset.licensechecked === "1")) {
      const resLiscWrapS = createCustomElement("span", { "class": ["detailsDesc", "licAbbr"] }, {}, "");
      const resLiscS = createCustomElement("a", { "class": ["resultLicense"] }, { "href": record['license'], "target": "_blank" }, record['license_abbr']);
      resLiscWrapS.append(resLiscS);
      resAccessRightCol.append(resLiscWrapS)
    }



    dspaceDetailsWrap5.append(resAccWrap);
    dspaceDetailsWrap5.append(resAccessRightCol);
    detailsDiv.append(dspaceDetailsWrap5);
  }
  else if (record['license'] && (resultsDiv.dataset.licensechecked === "1")) {
    const dspaceDetailsWrap6 = createCustomElement("div", { "class": ["dspaceDetails"] }, {});
    const resLiscWrap = createCustomElement("p", { "class": ["detailsDesc", "detailsLicense"] }, {}, "Licence");
    const resLisc = createCustomElement("a", { "class": ["resultLicense"] }, { "href": record['license'], "target": "_blank" }, record['license_abbr']);
    dspaceDetailsWrap6.append(resLiscWrap);
    dspaceDetailsWrap6.append(resLisc);
    detailsDiv.append(dspaceDetailsWrap6);
  }




  if (record['peer'] && (resultsDiv.dataset.peerrevchecked === "1")) {
    const dspaceDetailsWrap3 = createCustomElement("div", { "class": ["dspaceDetails"] }, {});
    const resProjWrap = createCustomElement("p", { "class": ["detailsDesc", "detailsPeerRev"] }, {}, "Peer review status");
    const resProj = createCustomElement("p", { "class": ["resultPeer"] }, {}, record['peer']);
    dspaceDetailsWrap3.append(resProjWrap);
    dspaceDetailsWrap3.append(resProj);
    detailsDiv.append(dspaceDetailsWrap3);
  }






  if (record['doi'] && (resultsDiv.dataset.doichecked === "1")) {
    const dspaceDetailsWrap7 = createCustomElement("div", { "class": ["dspaceDetails"] }, {});
    const resDoiWrap = createCustomElement("p", { "class": ["detailsDesc", "resultLink"] }, {}, "Links");
    const resDldRightCol = createCustomElement("p", { "class": ["resultDld"] }, {}, "");
    const resDOI = createCustomElement("a", { "class": ["resultHref"] }, { "href": record['doi'], "target": "_blank" }, record['doi']);
    resDldRightCol.append(resDOI);
    resDOI.addEventListener("click", function (evt) {
      let downloadClicked = new IfResourceEvent('ifpri_res_doi', record.handle);
      downloadClicked.sendEvent();
    });



    if (record['uri'] && (resultsDiv.dataset.linkchecked === "1")) {
      const dspaceDetailsWrap7a = createCustomElement("div", { "class": ["dspaceDetails"] }, {});
      const resLinkWrap = createCustomElement("span", { "class": ["detailsDesc", "repRecord"] }, {}, "");
      const resPara = createCustomElement("span", { "class": ["resSource"] });
      const resLink = createCustomElement("a", { "class": ["resultHref"] }, { "href": record['uri'], "target": "_blank" }, "Source record");
      resLinkWrap.append(resLink);
      resPara.append(resLinkWrap)
      resDldRightCol.append(resPara);
      resLink.addEventListener("click", function (evt) {
        let downloadClicked = new IfResourceEvent('ifpri_res_source', record.handle);
        downloadClicked.sendEvent();
      });

    }
    dspaceDetailsWrap7.append(resDoiWrap);
    dspaceDetailsWrap7.append(resDldRightCol);

    detailsDiv.append(dspaceDetailsWrap7);
  }

  else if (record['uri'] && (resultsDiv.dataset.linkchecked === "1")) {
    const dspaceDetailsWrap8 = createCustomElement("div", { "class": ["dspaceDetails"] }, {});
    const resLinkWrap = createCustomElement("p", { "class": ["detailsDesc", "SourceLink"] }, {}, "Link");
    const resLinkWrap2 = createCustomElement("p", { "class": ["detailLinkWrap"] });
    const resLink = createCustomElement("a", { "class": ["resultHref"] }, { "href": record['uri'], "target": "_blank" }, "Source record");
    dspaceDetailsWrap8.append(resLinkWrap);
    resLinkWrap2.append(resLink);
    dspaceDetailsWrap8.append(resLinkWrap2);
    detailsDiv.append(dspaceDetailsWrap8);
    resLink.addEventListener("click", function (evt) {
      let downloadBClicked = new IfResourceEvent('ifpri_res_source', record.handle, resultsDiv);
      downloadBClicked.sendEvent();
    });



  }


  if (record['project'] && (resultsDiv.dataset.projectchecked === "1")) {
    const dspaceDetailsWrap3 = createCustomElement("div", { "class": ["dspaceDetails"] }, {});
    const resProjWrap = createCustomElement("p", { "class": ["detailsDesc", "detailsProject"] }, {}, "Project");
    const resProj = createCustomElement("p", { "class": ["resultProj"] }, {}, record['project']);
    dspaceDetailsWrap3.append(resProjWrap);
    dspaceDetailsWrap3.append(resProj);
    detailsDiv.append(dspaceDetailsWrap3);
  }

  if (record['type'] && (resultsDiv.dataset.typechecked === "1")) {
    const dspaceDetailsWrapType = createCustomElement("div", { "class": ["dspaceDetails"] }, {});
    const resTypeWrap = createCustomElement("p", { "class": ["detailsDesc", "detailsType"] }, {}, "Record Type");
    const resType = createCustomElement("p", { "class": ["resultTypeSearch"] }, {}, record['type']);
    dspaceDetailsWrapType.append(resTypeWrap);
    dspaceDetailsWrapType.append(resType);
    detailsDiv.append(dspaceDetailsWrapType);
  }



  if (resultsDiv.dataset.downloadbtnchecked !== "1" && record['downloadLink'] && resultsDiv.dataset.downloadchecked === "1") {
    const dspaceDetailsWrap9 = createCustomElement("div", { "class": ["dspaceDetails"] }, {});
    const resDownwrap = createCustomElement("p", { "class": ["detailsDesc", "SourceLink"] }, {}, "Download");
    const resLink2 = createCustomElement("a", { "class": ["resultDownload"] }, { "href": record['downloadLink'], "target": "_blank" }, "Download");


    dspaceDetailsWrap9.append(resDownwrap);
    dspaceDetailsWrap9.append(resLink2);
    detailsDiv.append(dspaceDetailsWrap9);

    resLink2.addEventListener("click", function (evt) {
      let downloadBClicked = new IfResourceEvent('ifpri_res_download_search', record.handle, resultsDiv);
      downloadBClicked.sendEvent();
    });
  }

  if (resultsDiv.dataset.downloadbtnchecked === "1" && record['downloadLink']) {
    const resLink2a = createCustomElement("button", { "class": ["resourceDownloadBtn", "ifResBtn"] });
    const dspaceDetailsWrap9a = createCustomElement("a", { "class": ["searchDownload"] }, { "href": record['downloadLink'], "target": "_blank" }, "Download");
    resLink2a.append(dspaceDetailsWrap9a);
    detailsDiv.append(resLink2a);
    resLink2a.addEventListener("click", function (evt) {
      let downloadBClicked = new IfResourceEvent('ifpri_res_download_search', record.handle, resultsDiv);
      downloadBClicked.sendEvent();
    });

  }

  /************************************************************************* */

  return detailsDiv;
}


function displayGeneral(dataObj, resultsDiv, numResults, searchtype = "") {

  const parentSearchDiv = resultsDiv.closest(".ifpriResourcesSearchBlock");


  const nextElement = parentSearchDiv.nextElementSibling;
  let posttypes = [];
  /* if (urlParams.has("post_type[]")) {
    urlParams.forEach((value, key) => {
      if (key ==="post_type[]") {
        posttypes.push(value.slice(0, 50));
      }
    });
  }

  if (posttypes.length === 1 && posttypes.includes('publication')) {
    nextElement.innerHTML ="";
  }*/

  let targetList;
  let searchEngine;
  /* const allSearchResults = resultsDiv.querySelector('.ifpriResourcesSearchBlock ~ section') */

  if (nextElement.nodeName === "SECTION" && nextElement.classList.contains('search_filter')) {
    /* For search filter results */
    searchEngine ="searchFilter";
    targetList = nextElement.querySelectorAll("li");
  }
  else {
    searchEngine ="elasticSearch";
    //resultsDiv = nextElement.nextElementSibling;
    targetList = nextElement.querySelectorAll("div.blog-result");
  }

  


    function randomIntBetween(min,max){
      Math.floor(Math.random()*(max - min + 1)) + min
    }   
    const minn = 1;
    const maxn = targetList.length;

    const randomArray = Array.from({length: numResults+1}, () => Math.floor(Math.random() * (maxn - minn) + minn));
    randomArray.sort(function(a, b) {
      return a - b;
    })
    //console.log(`random array ${randomArray}`);
    let numberFound =dataObj.data.records.length;
    let foundText ="";
    if (numberFound === 1 ) {
      foundText = "One Publication";
     }
    else { 
      foundText =  "Displaying " + numberFound + " Publications"; 
    }

    if (targetList.length < 5) {
       const titlePublications = createCustomElement("p", { "class": ["seaarchResultsText"], "style": "margin-bottom:var(--wp--preset--spacing--small);margin-top:0;border-bottom:0; weight: bold;" }, {}, foundText);
       nextElement.append(titlePublications);
    }
    const totalFound = targetList.length + numberFound;

  dataObj.data.records.forEach(function (record, index) {
    if (!record.title) { return; }
    /* wrappers */

    const thetype = (record['type']) ? record['type'] : "";
    const thetitle = (record['title']) ? record['title'] : "";
    const theseries = (record['series']) ? record['series'] : "";
    const theissued = (record['issued']) ? record['issued'] : "";
    const theauthors = (record['authorsArray'].length > 0) ? record['authorsArray'].join("; ") : "";
    let thelink = "/publications";
    let theDldTxt = "More";

    if (record['downloadLink']) {
      thelink = record['downloadLink'];
      theDldTxt = "Download";
    }
    else if (record['uri']) {
      thelink = record['uri'];
      theDldTxt = "View";
    }


    if (!record.title) { return; }
    let detailsAppend = createCustomElement("details", { "class": ["detailsItem"] });

    const summaryAppend = createCustomElement("summary", { "class": ["recordDetails", "ifResBtn", "generalSearch"] }, { "title": "click to view more" }, "Details");
    detailsAppend.append(summaryAppend);
    summaryAppend.addEventListener("click", function (evt) {
      let detailsClicked = new IfResourceEvent('ifpri_res_details_click', record.handle, resultsDiv);
      detailsClicked.sendEvent();
    })


    


    let detailsDiv = createCustomElement("div", { "class": ["recordDetailsDiv"] });
    
    detailsDiv = createRecordDetails(record, resultsDiv, detailsDiv);
    detailsAppend.append(detailsDiv)

 

    const searchli = createCustomElement("li", { "class": ["wp-block-post"] });
    const blockcols = createCustomElement("div", { "class": ["wp-block-columns", "ifpri-column-gap", "is-layout-flex", "wp-block-columns-is-layout-flex"] });
    const blockcol1 = createCustomElement("div", { "class": ["wp-block-column", "is-layout-flow", "wp-block-column-is-layout-flow"] }, { "style": "flex-basis:33.33%" });
    const figure = createCustomElement("figure", { "class": ["wp-block-post-featured-image", "thumbnail_profile_search", "thumbnail_general_search"] }, { "style": "object-fit: cover;" });
    /* const img = createCustomElement("img", {"class":["attachment-medium","size-medium","wp-post-image"]}, {"width" : "300px", "height": "200px", "src": "https://ifpri.ruadesign.eu/wp-content/uploads/res_dspace/141/10568_141858_thumb.jpg"}); */
    let imgAppend;

    const imageFile = record.thumbLocal;
  
    let imgFull = "res_dspace/resource.jpg"
    if (imageFile !== "resource.jpg") {
      const subfolderName = imageFile.substr(6, 3);
      imgFull = "res_dspace/" + subfolderName + "/" + imageFile;
    }



    if (record.collection && record.collection.substr(1, 4) ==="p157")  { 
      imgFull = "res_ebrary/" +imageFile; 
    }


    imgAppend = createCustomElement("img", { "class": ["resourceThumb", "repositoryThumb", "genSearchImg"] }, { "title": "Cover of publication or resource", "src": "/wp-content/uploads/" + imgFull }, "Details");



    //const link1 = createCustomElement("a", {}, {"href": record['downloadLink'], "target":"_blank"}, "");
    const link2btn = createCustomElement("button", { "class": ["resourceDownloadBtn", "ifResBtn", "ifResBtnGeneral"] });
    const link2 = createCustomElement("a", { "class": ["searchDownload"] }, { "href": thelink, "target": "_blank" }, theDldTxt);
    link2btn.append(link2)
    let blockWidth = "100%";
    if (searchEngine === "searchFilter") {
      blockWidth = "61.66%";
    }


    const blockcol2 = createCustomElement("div", { "class": ["wp-block-column", "ifResColGeneral", "is-vertically-aligned-top", "is-layout-flow", "wp-block-column-is-layout-flow"] }, { "style": "flex-basis:" + blockWidth });
    const blockgrp = createCustomElement("div", { "class": ["wp-block-group", "meta-info", "has-body-2-size-font-size", "has-sourceserif-4-font-family", "has-ifpri-gray-1-color", "italic", "is-layout-flex", "wp-block-group-is-layout-flex"] }, { "style": "margin-top:0;margin-bottom:var(--wp--preset--spacing--medium); font-weight:bold; font-style: italic" });

    const span1 = createCustomElement("span", {}, {}, thetype);
    const span2 = createCustomElement("span", { "class": ["dspaceSub", "year", "resultYear"] }, {}, theissued);
    const span3 = createCustomElement("span", { "class": ["dspaceSub", "ifresAuthors"] }, {}, theauthors);
    const titleh4 = createCustomElement("h4", { "class": ["wp-block-post-title", "ifResourcesTitle", "ifResTitleGeneral"], "style": "margin-bottom:var(--wp--preset--spacing--small);margin-top:0;" }, {}, thetitle);
    figure.append(imgAppend)
    blockcol1.append(figure)
    if (searchEngine === "searchFilter") {
      blockcols.append(blockcol1)
    }

    blockgrp.append(span1)
    blockcol2.append(blockgrp)
    blockcol2.append(titleh4)
    blockcol2.append(span2)
    blockcol2.append(span3)
    blockcol2.append(detailsAppend)

   // blockcol2.append(link2btn)

    blockcols.append(blockcol2)
    searchli.append(blockcols)
    
    titleh4.addEventListener("click", function (e) {


      e.preventDefault();
      const parnt = titleh4.closest(".wp-block-column");
      if (parnt) {
        const detals = parnt.querySelector("details");
        if (detals) {
          if (detals.open == false) {
            detals.open = true;
          }
          else {
            detals.open = false;

          }

        }
        else {
          console.log('no details');
        }
      }
      else {
        console.log('no prt');
      }
    });

    /* wrappers */
    const thehr = createCustomElement("hr", { "class": ["wp-block-separator", "has-text-color", "has-ifpri-gray-1-color", "has-alpha-channel-opacity", "has-ifpri-gray-1-background-color", "has-background", "ifpri-post-spacer", "is-style-default"] }, { "style": "margin-top:0;margin-bottom:var(--wp--custom--spacing--40-to-30)" });


    // allSearchResults.append(searchli);
    if (targetList.length >5) {
     targetList[randomArray[index]].append(thehr)
     targetList[randomArray[index]].append(searchli)


    }
    else {
      nextElement.append(thehr)
      nextElement.append(searchli)
    }




  });
  if (targetList.length >5) {
    const recordFoundText = document.querySelector('.results_found');
    if (recordFoundText) {
      const elasticFound = recordFoundText.dataset.numberfound;
      const newTotalFound = parseInt(elasticFound) + numberFound;
      if (elasticFound) {
        recordFoundText.innerHTML="";
        const foundPublications = createCustomElement("span", { "class": ["foundTextPublications"] }, {}, "Found " + newTotalFound + " Results");
        recordFoundText.append(foundPublications)
      }
      
    }
  }

}

function createPaging(resultsDiv, totalRecords = 0) {

  if (totalRecords === 0) {

    const records = resultsDiv.querySelectorAll(".resultsItem:not(.filterHidden)");
    totalRecords = records.length;
  }


  const resultsParent = resultsDiv.closest(".ifpriResourcesSearchBlock");
  if (resultsParent) {
    const existingPagers = resultsParent.querySelectorAll('.resourcesPagerSection');
    existingPagers.forEach(function (pager) {
      pager.remove();

    });
  }
  else {

    if (numFound <= numRequested) {
      createAPIpage(searchForm, resultsDiv, numFound, numRequested);
    }
    return true;
  }

  let pagingAmt = resultsDiv.dataset.pagingnumber;

  let pagingAmountNum = parseInt(pagingAmt);

  if (pagingAmountNum >= totalRecords) { /* console.log ('No paging');*/
    const resourcesPagerSection = createCustomElement("div", { "class": ["resourcesPagerSection"] }, { "data-totalrecs": "20", "data-pagenum": pagingAmt });
    const numberRecordsDisplay = createCustomElement("div", { "class": ["numberRecordsDisplay"] }, {}, "Total " + totalRecords + " records");

    resourcesPagerSection.append(numberRecordsDisplay);
    resultsDiv.append(resourcesPagerSection);
    return;
  }
  /* console.log('Applying paging');*/
  const resourcesPagerSection = createCustomElement("div", { "class": ["resourcesPagerSection"] }, { "data-totalrecs": "20", "data-pagenum": pagingAmt });
  const resPageNav = createCustomElement("button", { "class": ["resPageNav", "resPagePrev", "navBtnHidden", "ifResBtn"] }, { "data-pagelow": "0", "data-pagedir": "prev" }, "Previous");
  const resPageFrom = createCustomElement("span", { "class": ["resPageFrom"] }, {}, "1");
  const resPageTxt = createCustomElement("span", { "class": ["resPageTxt"] }, {}, "to ");
  const resPageTo = createCustomElement("span", { "class": ["resPageTo"] }, {}, pagingAmt);
  const resPageTotal = createCustomElement("span", { "class": ["resPageTotal"] }, {}, "of " + totalRecords);
  const resPageNav2 = createCustomElement("button", { "class": ["resPageNav", "resPageNext", "ifResBtn"] }, { "data-pagedir": "next" }, "Next");
  resourcesPagerSection.append(resPageNav, resPageFrom, resPageTxt, resPageTo, resPageTotal, resPageNav2)





  const resourcesPagerSectionClone = resourcesPagerSection.cloneNode(true);


  let innerResults = resultsDiv.querySelector(".resourcesOutputsInnerWrapper");
  const innerSorting = resultsParent.querySelector(".totalAndSorting");


  if (innerResults) {

    if (innerSorting) {

      innerSorting.insertAdjacentElement("afterend", resourcesPagerSection);
    }
    else {
      innerResults.prepend(resourcesPagerSection)
    }
    innerResults.append(resourcesPagerSectionClone)
  }
  else {
    if (innerSorting) {
      innerSorting.insertAdjacentElement("afterend", resourcesPagerSection);
    }
    else {
      resultsDiv.append(resourcesPagerSectionClone);
    }
    resultsDiv.prepend(resourcesPagerSection)
  }

  addPagingListeners(resultsDiv, totalRecords)
  /*********************  Apply initial paging *********************/
  const records = resultsDiv.querySelectorAll(".resultsItem:not(.filterHidden)");
  records.forEach(function (record, index) {
    record.classList.add("resourceHidden");
    if (index < pagingAmountNum) {
      record.classList.remove("resourceHidden");
    }

  });

}
/*--------------------------------- Paging listners ---------------------------------*/

function addPagingListeners(resultsDiv, totalRecords) {


  const pagingNumber = resultsDiv.dataset.pagingnumber;
  const pagingNum = parseInt(pagingNumber);
  const pagingNavs = resultsDiv.querySelectorAll('.resPageNav');

  pagingNavs.forEach(function (pagingNav) {
    pagingNav.addEventListener("click", function (evt) {
      const resBtnPrev = document.querySelectorAll('.resPagePrev');
      const resPageNext = document.querySelectorAll('.resPageNext');



      const padingDir = pagingNav.dataset.pagedir;
      const pagingLowNum = parseInt(resBtnPrev[0].dataset.pagelow);
      let pagingNewLow;
      if (padingDir === "next") {
        pagingNewLow = pagingLowNum + pagingNum;
      }
      else {
        pagingNewLow = pagingLowNum - pagingNum;

      }
      let pagingNewHigh = pagingNewLow + pagingNum;
      const apiPagings = resultsDiv.querySelectorAll('.resLoadMore');
      if (pagingNewHigh >= totalRecords) {
        pagingNewHigh = totalRecords;
        resPageNext.forEach(function (resBtnNext12) {
          resBtnNext12.classList.add("navBtnHidden")
        });
        apiPagings.forEach(function (apiPaging) {
          apiPaging.classList.remove('resLoadMoreHidden')
        })

      }
      else {
        resPageNext.forEach(function (resBtnNext12) {
          resBtnNext12.classList.remove("navBtnHidden")
        })
        apiPagings.forEach(function (apiPaging) {
          apiPaging.classList.add('resLoadMoreHidden')
        })


      }
      if (pagingNewLow <= 0) {
        pagingNewLow = 0;
        resBtnPrev.forEach(function (resBtnPrev12) {
          resBtnPrev12.classList.add("navBtnHidden")
        });
      }
      else {
        resBtnPrev.forEach(function (resBtnPrev12) {
          resBtnPrev12.classList.remove("navBtnHidden")
        });

      }

      resBtnPrev[0].dataset.pagelow = pagingNewLow;
      const records = resultsDiv.querySelectorAll(".resultsItem:not(.filterHidden)");

      const resourcesPagerSections = resultsDiv.querySelectorAll('.resourcesPagerSection');
      resourcesPagerSections.forEach(function (resourcesPagerSection) {

        const lowValue = resourcesPagerSection.querySelector('.resPageFrom');
        const highValue = resourcesPagerSection.querySelector('.resPageTo');
        lowValue.textContent = pagingNewLow + 1;
        highValue.textContent = pagingNewHigh;

      });

      records.forEach(function (record, index) {

        if (index >= pagingNewLow && index < pagingNewHigh) {
          record.classList.remove("resourceHidden");
        }
        else {
          record.classList.add("resourceHidden");
        }
      });
      scrollbackTop(resultsDiv);

    });
  });

}
/*--------------------------------- End Paging listners ---------------------------------*/

/*-------------------------Sorting section -------------------------------------*/

function createSorting(resultsDiv, totalRecords) {

  const resultsParent = resultsDiv.closest(".ifpriResourcesSearchBlock");
  if (resultsParent) {
    const nearestResults = resultsParent.querySelector(".resourcesOutputsInnerWrapper");
    const totalAndSorting = createCustomElement("div", { "class": ["totalAndSorting"] });
    //const searchFormTop = createCustomElement("div", {"class":["searchFormTop"]});
    const resultsTotal = createCustomElement("div", { "class": ["numberRecordsDisplay"] }, {}, "Total " + totalRecords + " records");
    const resultsSort = createCustomElement("div", { "class": ["resultsSort"] });
    const resourcesResultsSort = createCustomElement("form", { "class": ["resourcesResultsSort"] }, { "action": "#", "method": "post" });
    const resources_sortSelect = createCustomElement("select", { "class": ["resources_sortSelect"] }, { "name": "order_recs", "value": "sortdate", "data-lastsort": "" });
    const res_sortingDate = createCustomElement("option", { "class": ["res_sorting"] }, { "value": "sortdate" }, "By date");
    const res_sortingTitle = createCustomElement("option", { "class": ["res_sorting"] }, { "value": "sorttitle" }, "By title");
    const res_sortingType = createCustomElement("option", { "class": ["res_sorting"] }, { "value": "sorttype" }, "By type");
    const res_sortingOrder = createCustomElement("span", { "class": ["resultsReverse"] });
    resources_sortSelect.append(res_sortingDate, res_sortingTitle, res_sortingType);
    resourcesResultsSort.append(resources_sortSelect, res_sortingOrder)
    resultsSort.append(resourcesResultsSort)

    sortingListenersBy(resources_sortSelect, resultsDiv, nearestResults);
    sortListnerDirection(res_sortingOrder, resultsDiv, nearestResults);

    totalAndSorting.append(resultsTotal, resultsSort)
    if (nearestResults) {
      nearestResults.prepend(totalAndSorting);
    }


  }
  else {

    console.log('not found');
  }


}

/*-------------------------Sorting section listeners -------------------------------------*/

function sortingListenersBy(resources_sortSelect, resultsDiv, nearestResults) {
  resources_sortSelect.addEventListener("change", function (evt) {
    evt.preventDefault();

    // const resultsParent = resultsDiv.closest(".ifpriResourcesSearchBlock");
    // const nearestResults = resultsParent.querySelector(".resourcesOutputsInnerWrapper");
    const resultsArray = nearestResults.querySelectorAll(".resourceItemRecord");
    const typeSort = evt.target.value.toLowerCase();

    function sortTitle(a, b) {
      if (a.dataset.sorttitle < b.dataset.sorttitle) { return -1; }
      if (a.dataset.sorttitle > b.dataset.sorttitle) { return 1; }
      return 0;
    }
    function sortDate(a, b) {
      if (a.dataset.sortdate < b.dataset.sortdate) { return -1; }
      if (a.dataset.sortdate > b.dataset.sortdate) { return 1; }
      return 0;
    }
    function sortType(a, b) {
      if (a.dataset.sorttype < b.dataset.sorttype) { return -1; }
      if (a.dataset.sorttype > b.dataset.sorttype) { return 1; }
      return 0;
    }
    let sortItems;
    // Sort the array by age in ascending order
    let lastSort = resources_sortSelect.dataset.lastsort;

    if (lastSort === typeSort) {
      sortItems = Array.from(resultsArray).reverse()
    }
    else if (typeSort === "sorttitle") {
      sortItems = Array.from(resultsArray).sort(sortTitle);
    }
    else if (typeSort === "sortdate") {
      sortItems = Array.from(resultsArray).sort(sortDate);
    }
    else if (typeSort === "sorttype") {
      sortItems = Array.from(resultsArray).sort(sortType);
    }
    resources_sortSelect.dataset.lastsort = typeSort;
    sortItems.forEach(item => nearestResults.appendChild(item));
    createPaging(resultsDiv);

  });

}

function sortListnerDirection(resources_sortSelect, resultsDiv, nearestResults) {
  resources_sortSelect.addEventListener("click", function (evt) {

    //const resultsParent = resultsDiv.closest(".ifpriResourcesSearchBlock");
    //const nearestResults = resultsParent.querySelector(".resourcesOutputsInnerWrapper");
    const resultsArray = nearestResults.querySelectorAll(".resourceItemRecord");
    const reverseItems = Array.from(resultsArray).reverse()
    reverseItems.forEach(item => nearestResults.appendChild(item));
    createPaging(resultsDiv);
  });
}

/*-------------------------End Sorting section listeners -------------------------------------*/






function createVerticalFilters(recordset) {
  const outputFiltersVertical = createCustomElement("section", { "class": ["filters", "output-filters-vertical"] });

  const filtersArray = [{ "label": "Type", "filter": "types" }, { "label": "Author", "filter": "authors" }, { "label": "Keyword", "filter": "keywords" }, { "label": "Country", "filter": "countries" }, { "label": "Year", "filter": "years" }]
  let i = 0;
  filtersArray.forEach(function (elm) {
    i++;
    if (recordset[elm.filter].length === 0) { return; /* could also convert to for loop here */ }
    const filtersInner = createCustomElement("div", { "class": ["filters-inner"] });
    const filtersForm = createCustomElement("form", { "class": ["filters_form_vertical"] }, { "action": "#", "method": "get" })
    const filterDetailsOuter = createCustomElement("div", { "class": ["filters_details-outer"] })
    let filterDetails;
    if (i === 1) {
      filterDetails = createCustomElement("details", { "class": ["filters-details"] }, { "open": "open" })
    }
    else {
      filterDetails = createCustomElement("details", { "class": ["filters-details"] })
    }
    const filterSummary = createCustomElement("summary", { "class": ["filters_summary"] })
    const filterSummaryHead = createCustomElement("h5", {}, {}, elm.label)
    const filterInputDiv = createCustomElement("div", { "class": ["filtersInput", "anyHidden"] })
    /* Note: if elm.lable has a space, there will be issue here */


    const filterInputList = createCustomElement("div", { "class": ["resFiltersList"] })
    const fitlerInput = createCustomElement("input", { "id": elm.label + "any", "class": ["opinput", "anyHidden"] }, { "type": "checkbox", "name": elm.label + "any", "value": "" })
    const filterLabel = createCustomElement("label", {}, { "for": elm.label + "any" }, "Any")
    filterInputDiv.append(fitlerInput);
    filterInputDiv.append(filterLabel);
    filterDetailsOuter.append();
    filterSummary.append(filterSummaryHead);
    


    filterDetails.append(filterSummary);
    filterDetails.append(filterInputDiv);

    recordset[elm.filter].forEach(function (filtLbl, index) {
      if (filtLbl !== "") {
        const filterInputInner = createCustomElement("div", { "class": ["filtersInput"] })
        const filterInputEl = createCustomElement("input", { "id": "flt_" + elm.label + index, "class": ["opinput"] }, { "type": "checkbox", "name": "flt_" + elm.label + index, "value": filtLbl })
        addFilterInputListener(filterInputEl, filtersForm)
        const filterLabel = createCustomElement("label", {}, { "for": "flt_" + elm.label + index }, filtLbl)
        filterInputInner.append(filterInputEl)
        filterInputInner.append(filterLabel)

        filterInputList.append(filterInputInner)
        
        

      }

    });
    
    filterDetails.append(filterInputList)
    
 
    
    filterDetailsOuter.append(filterDetails);
    filtersForm.append(filterDetailsOuter)
    filtersInner.append(filtersForm)
    outputFiltersVertical.append(filtersInner)
    
  })
  const searchInRslts = createCustomElement("form", { "class": ["resourcesResultsSearch", "resourcesSearchJS" ] }, { "action": "#", "method": "post" })
  const searchInRsltsInput1 =  createCustomElement("input", { "class": ["ifres-searchinput"] }, { "type": "search", "name": "resourcesResultsSearchInpt", "placeholder": "Search within results" })
  const searchInRsltsInput2 =  createCustomElement("input", { "class": ["ifres-searchsubmit"] }, { "type":"submit", "alt": "Search", "value": "Search", "name": "save_data" })
  const searchInRsltsInput3 =  createCustomElement("div", { "class": ["clearSearchElm", "hidden"] }, { "role": "button", "title": "Clear Search Results" }, "X")
  searchInRslts.append(searchInRsltsInput1,searchInRsltsInput2,searchInRsltsInput3)
  outputFiltersVertical.append(searchInRslts)
  searchWithinResults(searchInRsltsInput2);
  return (outputFiltersVertical)
}


/*------------------------------------------------------------------------------------------------
/*  Resources in-page search / Search within
--------------------------------------------------------------------------------------------------------*/
/* Treat like a filter --- using filterHidden */
function searchWithinResults(elmSubmit) {
  elmSubmit.addEventListener('click', function(e) {
    e.preventDefault();
    const nearestForm = elmSubmit.closest(".resourcesResultsSearch");
    let searchCount =  0; 

    const parentContainer = elmSubmit.closest(".ifpriResourcesSearchBlock");
    const resultsDiv = parentContainer.querySelector(".resourcesDisplaySection");
   /* let resourcesContainer = resourcesLeftFilters.closest(".globalIfResStyle");
    let searchContainer = resourcesLeftFilters.closest(".ifpriResourcesSearchBlock");
    resourcesContainer.classList.add("resourcesSearched");
    searchContainer.classList.add("resourcesSearched");*/
    let recordsToSearch = resultsDiv.querySelectorAll(".resourceItemRecord");



    if (nearestForm){
      let formData = nearestForm.elements;
      const searchTerm = formData["resourcesResultsSearchInpt"].value.toLowerCase();
      if (searchTerm && searchTerm !=="") {
          let recordsToSearch = document.querySelectorAll(".resourceItemRecord");
         
          recordsToSearch.forEach((recItem) => {
            recItem.classList.add('filterHidden');
            let itemTerms = recItem.dataset.allterms;
            let title = recItem.querySelector('.ifResourcesTitle');
            if(title) { 
              const titleText = " " + title.textContent;
              itemTerms += titleText;
            }
            else { console.log('no title '); }
            let abstract = recItem.querySelector('.ifResourcesAbstract');
            if(abstract) { 
               const absText = " " + abstract.textContent;
              itemTerms += absText;
            }
            if (itemTerms.toLowerCase().includes(searchTerm)) {
              recItem.classList.remove('filterHidden');
              searchCount++;
            }

          });
          if (searchCount === 0) {
            let clearSearch = document.querySelector('.clearSearchElm');
            if (clearSearch) {
              clearSearch.classList.remove('hidden');
              clearSearch.addEventListener('click', function() {
                recordsToSearch.forEach((recItem) => {
                    recItem.classList.remove('filterHidden');
                });
                clearSearch.classList.add('hidden');
              })
            }

          }
      }
      else {
        console.log('nothing searched for');
      }

    }


    createPaging(resultsDiv);
    
  });

}


function addFilterInputListener(inputElm, resourcesLeftFilters) {

  inputElm.addEventListener('change', function (clickSubmit) {

    /* previously used 'searchShown'*/
    const parentContainer = inputElm.closest(".ifpriResourcesSearchBlock");
    const resultsDiv = parentContainer.querySelector(".resourcesDisplaySection");
    let resourcesContainer = resourcesLeftFilters.closest(".globalIfResStyle");
    let searchContainer = resourcesLeftFilters.closest(".ifpriResourcesSearchBlock");
    resourcesContainer.classList.add("resourcesFiltered");
    searchContainer.classList.add("resourcesFiltered");

    const nearestForm = inputElm.closest(".filters_form_vertical");

    let recordsToSearch = resultsDiv.querySelectorAll(".resourceItemRecord");
    if (nearestForm) {
      let formData = new FormData(nearestForm);

      /*Show matching */

      if (Array.from(formData.keys()).length > 0) {

        /* Hide all */
        recordsToSearch.forEach((recItem) => {
          recItem.classList.add('filterHidden');
          recItem.classList.remove('resourceHidden');
        });

        for (const row of formData.entries()) {
          if (row[1] === "") { return; }
          const searchTerm = row[1].toLowerCase();

          if (searchTerm && searchTerm !== "") {

            let i = 0;
            
            recordsToSearch.forEach((recItem) => {


              const itemTerms = recItem.dataset.allterms;
              let itemTermsArr = itemTerms.split(";");
              let itemTermsArray = itemTermsArr.filter(function (el) { return el != ""; });
              let titleAbst = "";

              const title = recItem.querySelector('.ifResourcesTitle');
              if (title) {
                titleAbst += title;
              }
              let abstract = recItem.querySelector('.ifResourcesAbstract');
              if (abstract) {
                const absText = " " + abstract.textContent;
                titleAbst += absText;
              }

              if (itemTermsArr.some(element => { return element.toLowerCase() === searchTerm })) {
                recItem.classList.remove('filterHidden');
                i++;
              }
              else if (titleAbst.toLowerCase().includes(searchTerm)) {
                recItem.classList.remove('filterHidden');
              }
            });


            createPaging(resultsDiv, i);


          }
        }


      }
      else {
        /* Show all */
        recordsToSearch.forEach((recItem) => {
          recItem.classList.remove('filterHidden');
        });
        resourcesContainer.classList.remove("resourcesFiltered");
        searchContainer.classList.remove("resourcesFiltered");

        createPaging(resultsDiv, recordsToSearch.length);

      }

    }
  })




}



function removeCitationAndPagers() {

  const pagerElms = document.querySelectorAll('.ifResCitPaging');
  pagerElms.forEach(function (elm) {
    elm.remove();
  })
}


function scrollbackTop(el) {
  const backToElm = el.querySelector('div');
  if (backToElm) {
      const yOffset = -200; 
      const element = el.querySelector('div');
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset; 
      window.scrollTo({top: y, behavior: 'smooth'});
      //window.scrollTo({ top: top1, behavior: 'smooth' });
  }
}


/*--------------------------------------------------------------------*/
/*   Copy text to clipboard - used in displayResults function        */
/*--------------------------------------------------------------------*/

async function copyTextToClipboard(textToCopy) {
  try {
    if (navigator?.clipboard?.writeText) {
      await navigator.clipboard.writeText(textToCopy);
      return true;
    }
  } catch (err) {
    console.error(err);
    return false;
  }
}


/*----------------------------------------------*/
/*   Create html element with text            */
/*----------------------------------------------*/

function createCustomElement(type, idclasses = [], attributes = [], innerText = "") {

  /* example :  archiveBtn = createCustomElement("button", { "id": "button1", "class": ["ctrlButton", "archiveBtnBtm"]}, {"data-dataid": dataId }); */
  const element = document.createElement(type);
  for (const key in idclasses) {
    if (key == "class") {
      /* classes cannot have spaces when added */
      const className = idclasses[key];
      element.classList.add.apply(element.classList, idclasses[key]); // add all classes at once
    } else {
      element[key] = idclasses[key];
    }
  }
  for (const key2 in attributes) {
    element.setAttribute(key2, attributes[key2]);
  }
  if (innerText != "") {
    const textToAppend = document.createTextNode(innerText);
    element.appendChild(textToAppend);
  }

  return element;
}

function betterHTML(str) {

  str = decodeURIComponent(str);
  return str;
};
function betterHTML2(str) {

  //str= str.replace(/[^\x00-\xFF]/g, "");
  //str = str.replace(/[^\w\s]/gi, '')
  betterHTML
  str = str.replace(/-/g, ' ');
  str = str.replace(/%E2%80%9C/g, '');
  str = str.replace(/%E2%80%9D/g, '');
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/normalize
  str = str.normalize("NFD").replace(/\p{Diacritic}/gu, "")
  str = encodeURI(str);
  return str.replace(/[^\w. ]/gi, function (c) {
    return '&#' + c.charCodeAt(0) + ';';
  });
};

/*----------------------------------------------*/
/* Empty the element     */
/*------------------------------------------*/
function emptyTheElement(theElement) {
  while (theElement.hasChildNodes()) {
    theElement.removeChild(theElement.firstChild);
  }
}

function dispalyAdminInfo(resultsDiv, message) {

  const adminInfo = resultsDiv.nextElementSibling;
  if (adminInfo) {
    const adminSection = adminInfo.querySelector('.adminDebugInfo');
    if (adminSection) {
      adminSection.innerHTML = "";

      let apiURL = '';
      const urlP = createCustomElement("p", { "class": ["admininfomsg"] }, {}, 'URL: ');


      if (message.query.substring(0, 4) == "p157") {
        if (isValidUrl(message.query)) {
          apiURL = message.query;
        }
        else {
          apiURL = 'https://server15738.contentdm.oclc.org/dmwebservices/index.php?q=dmQuery/' + message.query;
        }
      }
      else {
        if (isValidUrl(message.query)) {
          apiURL = message.query;
        }
        else {
          apiURL = 'https://cgspace.cgiar.org' + message.query;
        }

      }
      if (message.query2 && message.query2.substring(0, 4) == "p157") {
        if (isValidUrl(message.query2)) {
          apiURL = message.query2;
        }
        else {
          apiURL = 'https://server15738.contentdm.oclc.org/dmwebservices/index.php?q=dmQuery/' + message.query2;
        }
      }
      /* let urlStr = message.query;
      if( message.query.indexOf("https") == 0 ) {
         urlStr = apiURL + message.query;
      } */

      const urlA = createCustomElement("a", { "class": ["admininfomsg"] }, { "href": apiURL, "target": "_blank" }, apiURL);


      urlP.append(urlA)
      adminSection.append(urlP);
      adminSection.append(createCustomElement("p", { "class": ["admininfomsg"] }, {}, 'Caching: ' + message.cache + ' ' ));
      if (message.cache === "Records cached") {
        const queryString = window.location.search;

        if (queryString.includes("?")) {
          adminSection.append(createCustomElement("a", { "class": ["admininfomsg"] }, { "href": window.location.href
          + "&clearcache=1"}, 'Clear cache'));
        }
        else {
          adminSection.append(createCustomElement("a", { "class": ["admininfomsg"] }, { "href": window.location.href
          + "?clearcache=1"}, 'Clear cache'));
        }
 

      }
      adminSection.append(createCustomElement("p", { "class": ["admininfomsg"] }, {}, 'Status: ' + message.status));
      adminSection.append(createCustomElement("p", { "class": ["admininfomsg"] }, {}, 'Number found: ' + message.data.records.length));
      const analyticsInfo = createCustomElement("div", { "class": ["admininAnalytics"] }, {}, '')
      adminSection.append(analyticsInfo);
    }
  }

}

var ESC_MAP = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
};

function betterInput(s, forAttribute) {
  return s.replace(forAttribute ? /[&<>'"]/g : /[&<>]/g, function (c) {
    return ESC_MAP[c];
  });
}

const isValidUrl = urlString => {
  try {
    return Boolean(new URL(urlString));
  }
  catch (e) {
    return false;
  }
}

/******************************************************************************************************/
/*  Events to send to Google Analytics                                                                */
/*  Example:                                                                                          */
/*    let detailsClicked = new IfResourceEvent('Details clicked', record.handle, resultsDiv);         */
/*    detailsClicked.sendEvent();                                                                     */
/******************************************************************************************************/

function IfResourceEvent(evtTitle, handle, resultsDiv, redirectURL="N/A") {
	const url = new URL(window.location);
	this.handle = handle;
	this.evtTitle = evtTitle;
	this.redirect_url = redirectURL;
	this.url = url;
	this.gid = "G-9ET431M2SQ";
	/* used for reporting... */
	this.resultsDiv = resultsDiv;
  }
  
  IfResourceEvent.prototype.sendEvent = async function () {
  
	window.dataLayer = window.dataLayer || [];
	function gtag() { dataLayer.push(arguments); }
	gtag('js', new Date());
	gtag('config', this.gid, {
	  send_page_view: false
	});
	if(this.redirect_url !=="N/A") {
	  gtag('event', this.evtTitle, {
		resource_handle: this.handle,
		resource_query: this.url.search,
		resource_redirect: this.redirect_url,
		send_to: this.gid
	  })
	}
  
	else {
	  gtag('event', this.evtTitle, {
		resource_handle: this.handle,
		resource_query: this.url.search,
		send_to: this.gid
	  })
  
	}
  
	const message = `Type: ${this.evtTitle}, Record:  ${this.handle}, Gid:  ${this.gid},  ${this.url.search !=="" ? ", URL search : " + this.url.search : ""} `;
	console.log(message);
	if (this.resultsDiv) {
	  // appendAdminAnalytics(this.resultsDiv, message);
	}
  
	return true;
  }
  
  function appendAdminAnalytics(resultsDiv, message) {
  
	const adminSection = resultsDiv.nextElementSibling;
	if (adminSection) {
	  const adminSectionAnalytics = adminSection.querySelector('.admininAnalytics');
	  if (adminSectionAnalytics) {
			adminSectionAnalytics.append(createCustomElement("p", { "class": ["adminAnalyticsMsg"] }, {}, message));
	  }
  
	}
  
  }
